/**
 * rondo-web-forms
 *
 * Rondo Web Forms
 *
 * @author Jiri Hybek <jiri@hybek.cz>
 * @license See LICENSE file distributed with this source code.
 */

import { IFormData } from "./FormModel/IFormData";

export class InvalidFormDataError extends Error {}

/**
 * Validates form data
 *
 * @param data Form data
 */
export function validateFormData(data: IFormData) {

	if (!(data instanceof Object)) {
		throw new InvalidFormDataError("Data must be an object.");
	}

	if (!data.formId || typeof data.formId !== "string") {
		throw new InvalidFormDataError("Property 'formId' is missing in the data object or has invalid format.");
	}

	if (!data.formVersion || typeof data.formVersion !== "string") {
		throw new InvalidFormDataError("Property 'formVersion' is missing in the data object or has invalid format.");
	}

	if (!data.name || typeof data.name !== "string") {
		throw new InvalidFormDataError("Property 'name' is missing in the data object or has invalid format.");
	}

	if (!data.values) {
		throw new InvalidFormDataError("Property 'values' is missing in the data object.");
	}

	if (!(data.values instanceof Object)) {
		throw new InvalidFormDataError("Property 'values' must be an object.");
	}

}
